/** @jsx jsx */
import { jsx } from '@emotion/react';

import * as React from 'react';

import { truncate } from 'lodash';

import { Avatar, Grid, Link, Typography2 } from '@coursera/cds-core';

import IsMobileScreenContext from 'bundles/page/contexts/IsMobileScreenContext';
import type { AuthorProfile } from 'bundles/shared-articles/components/ArticleAuthorProfile';

const MAX_DESCRIPTION_LENGTH_MOBILE = 83;
const MAX_DESCRIPTION_LENGTH_DESKTOP = 103;

const ArticleAuthorProfilePreview = ({ name, description, jobTitle, image, url }: AuthorProfile) => {
  const { isMobileScreen } = React.useContext(IsMobileScreenContext);

  if (!name) {
    return null;
  }

  const imageProps = (image && { src: image, alt: name }) || undefined;

  return (
    <Grid container spacing={16} wrap="nowrap">
      <Grid item>
        <Avatar variant="user" size={64} showBorder={true} imgProps={imageProps} data-testid="author-avatar" />
      </Grid>
      <Grid item>
        <Typography2 component="h3" variant="subtitleMedium">
          {url ? (
            <Link href={url} variant="standard" typographyVariant="bodyPrimary" rel="author">
              <Typography2 variant="subtitleMedium" component="span" color="inherit">
                {name}
              </Typography2>
            </Link>
          ) : (
            name
          )}
        </Typography2>
        {jobTitle && (
          <Typography2 component="p" variant="bodySecondary">
            {jobTitle}
          </Typography2>
        )}
        {description && (
          <Typography2 component="p" variant="bodySecondary" color="supportText">
            {truncate(description, {
              length: isMobileScreen ? MAX_DESCRIPTION_LENGTH_MOBILE : MAX_DESCRIPTION_LENGTH_DESKTOP,
            })}
          </Typography2>
        )}
      </Grid>
    </Grid>
  );
};

export default ArticleAuthorProfilePreview;
